import { GridUtils, H1 } from '@atlassian/amkt-common';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScreenClassRender } from 'react-grid-system';

import styles from './SolutionHeading.less';

export default class SolutionHeading extends Component {
  static propTypes = {
    heading: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
  };

  render() {
    return (
      <ScreenClassRender render={this.renderHeading}>
        <span />
      </ScreenClassRender>
    );
  }

  renderHeading = (sc: any) => {
    const containerClassNames = [
      styles.solutionHeading,
      GridUtils.triFoldScreenClass(sc)(
        styles.smallSolutionHeading,
        styles.mediumSolutionHeading,
        styles.largeSolutionHeading
      ),
    ];

    return (
      <div className={classNames(containerClassNames)}>
        <div className={styles.solutionHeadingInner}>
          {/* @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'. */}
          <H1 className={styles.solutionTitle}>{this.props.heading}</H1>
          <div className={styles.imageContainer}>
            <div className={styles.imageWrapper}>
              <img
                className={styles.image}
                // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
                src={this.props.image}
                // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
                alt={`${this.props.category} category`}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
}
